import { Navigate } from 'react-router-dom';

/**
 * Incasso root — redirects to the kanban view.
 * The actual pages live at /rental/incasso/kanban and /rental/incasso/list.
 */
const Incasso = () => <Navigate to="/rental/incasso/kanban" replace />;

export default Incasso;
